(() => {
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(Number(cents || 0) / 100);
    } catch (_error) {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${currency || 'USD'}`;
    }
  };

  const initPurchase = (root) => {
    if (!root || root.dataset.cvS41tbReady === 'true') return;
    root.dataset.cvS41tbReady = 'true';

    const form = root.querySelector('[data-cv-s4-1tb-product-form]');
    if (!form) return;

    const quantity = form.querySelector('[data-cv-s4-1tb-quantity]');
    const minus = form.querySelector('[data-cv-s4-1tb-quantity-minus]');
    const plus = form.querySelector('[data-cv-s4-1tb-quantity-plus]');
    const mainButton = form.querySelector('[data-cv-s4-1tb-add]');
    const variantInput = form.querySelector('[data-cv-s4-1tb-variant-input]');
    const price = form.querySelector('[data-cv-s4-1tb-price]');
    const compare = form.querySelector('[data-cv-s4-1tb-compare]');
    const sku = form.querySelector('[data-cv-s4-1tb-sku]');
    const availability = form.querySelector('[data-cv-s4-1tb-availability]');
    const paymentTerms = form.querySelector('[data-cv-s4-1tb-payment-terms]');
    const hero = root.querySelector('[data-cv-s4-1tb-hero-image]');
    const variantDataNode = root.querySelector('[data-cv-s4-1tb-variants]');
    let variants = [];

    try {
      variants = JSON.parse(variantDataNode?.textContent || '[]');
    } catch (_error) {
      variants = [];
    }

    const currentVariant = () => variants.find((item) => String(item.id) === String(variantInput?.value));

    const syncFinal = (variant = currentVariant()) => {
      document.querySelectorAll(`[data-cv-s4-1tb-final][data-product-id="${root.dataset.productId}"]`).forEach((section) => {
        const finalButton = section.querySelector('[data-cv-s4-1tb-final-add]');
        const finalPrice = section.querySelector('[data-cv-s4-1tb-final-price]');
        const finalQuantity = section.querySelector('[data-cv-s4-1tb-final-quantity]');
        if (finalPrice && variant) finalPrice.textContent = money(variant.price, root.dataset.currency);
        if (finalQuantity && quantity) finalQuantity.textContent = quantity.value;
        if (finalButton && mainButton) {
          finalButton.disabled = mainButton.disabled;
          finalButton.setAttribute('aria-disabled', String(mainButton.disabled));
          finalButton.setAttribute('aria-busy', mainButton.getAttribute('aria-busy') || 'false');
          if (finalButton.dataset.cvS41tbBound !== 'true') {
            finalButton.dataset.cvS41tbBound = 'true';
            finalButton.addEventListener('click', () => {
              if (!mainButton.disabled) form.requestSubmit(mainButton);
            });
          }
        }
      });
    };

    const clampQuantity = (next) => {
      if (!quantity) return;
      const min = Number(quantity.min || 1);
      const max = quantity.max ? Number(quantity.max) : Number.POSITIVE_INFINITY;
      const step = Number(quantity.step || 1);
      const normalized = Math.max(min, Math.min(max, Number.isFinite(next) ? next : min));
      quantity.value = String(min + Math.round((normalized - min) / step) * step);
      syncFinal();
    };

    const bindQuantityButton = (button, direction) => {
      if (!button) return;
      const applyStep = () => clampQuantity(Number(quantity?.value || 1) + direction * Number(quantity?.step || 1));
      button.addEventListener('click', applyStep);
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        event.preventDefault();
        applyStep();
      });
    };

    bindQuantityButton(minus, -1);
    bindQuantityButton(plus, 1);
    quantity?.addEventListener('change', () => clampQuantity(Number(quantity.value)));
    quantity?.addEventListener('input', () => syncFinal());

    const selectedOptions = () => Array.from(form.querySelectorAll('[data-cv-s4-1tb-option]:checked')).map((input) => input.value);
    const updateVariant = () => {
      if (!variants.length || !variantInput) return;
      const options = selectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
      if (!variant) {
        mainButton?.setAttribute('disabled', '');
        mainButton?.setAttribute('aria-disabled', 'true');
        syncFinal();
        return;
      }

      variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price, root.dataset.currency);
      if (compare) {
        const onSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        compare.hidden = !onSale;
        compare.textContent = onSale ? money(variant.compare_at_price, root.dataset.currency) : '';
      }
      if (sku) sku.textContent = variant.sku || '';
      if (availability) availability.textContent = variant.available ? 'Available' : mainButton?.dataset.unavailableLabel || 'Unavailable';
      if (hero && variant.image) {
        hero.src = variant.image;
        hero.alt = variant.image_alt || hero.alt;
      }
      paymentTerms?.querySelectorAll('shopify-payment-terms').forEach((node) => node.setAttribute('variant-id', variant.id));
      if (mainButton) {
        mainButton.disabled = !variant.available;
        mainButton.setAttribute('aria-disabled', String(!variant.available));
        const label = mainButton.querySelector('[data-cv-s4-1tb-add-label]');
        if (label) label.textContent = variant.available ? mainButton.dataset.readyLabel : mainButton.dataset.unavailableLabel;
      }
      syncFinal(variant);
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };

    form.querySelectorAll('[data-cv-s4-1tb-option]').forEach((input) => input.addEventListener('change', updateVariant));
    form.addEventListener('submit', () => {
      if (!mainButton || mainButton.disabled) return;
      mainButton.setAttribute('aria-busy', 'true');
      const label = mainButton.querySelector('[data-cv-s4-1tb-add-label]');
      if (label) label.textContent = mainButton.dataset.loadingLabel;
      window.requestAnimationFrame(() => syncFinal());
    });
    if (mainButton) new MutationObserver(() => syncFinal()).observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
    syncFinal();
  };

  const init = (scope = document) => scope.querySelectorAll('[data-cv-s4-1tb-purchase]').forEach(initPurchase);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
